import {
  groupByDesign,
  useDesigns,
  useProduct,
  useProjectItems,
} from '@customink/project-service-react-components';

/**
 * An anchor product was traditionally a concept relevant to core orders,
 * defined as the first product in the design. In the brave new frontier of
 * project service, we have to consider that the project item may have a product
 * that isn't even in the design.
 *
 * This hook resolves that ambiguity by always returning a product from the
 * subset of project items grouped by the given design. If the design's anchor
 * product is among those project item products, it returns that. Otherwise,
 * it returns the first project item's product.
 **/

export function useAnchorProduct(designCid: string) {
  const designs = useDesigns();
  const design = designs[designCid || ''];
  const firstDesignedProduct = design?.products?.[0];
  const firstDesignedProductColorId = parseInt(
    firstDesignedProduct?.colorId,
    10,
  );

  const { data: projectItems } = useProjectItems();
  const groupedProjectItems = groupByDesign(projectItems || []);
  const designProjectItems = groupedProjectItems[designCid] || [];
  const firstProjectItemProduct = designProjectItems[0]?.product;
  const isDesignedProductInProjectItems = designProjectItems.find((item) => {
    return item.product?.colorId === firstDesignedProductColorId;
  });
  const anchorProductColorId = isDesignedProductInProjectItems
    ? firstDesignedProductColorId
    : firstProjectItemProduct?.colorId;

  const { data: product } = useProduct({ colorId: anchorProductColorId });

  return product;
}
